
import { formatSideLabel, isYesNoSide } from "@/lib/selection-side";

export function formatLine(line: number, betType: string): string {
  if (isYesNoSide(betType)) return formatSideLabel(betType);
  if (betType === "OVER" || betType === "UNDER") {
    return `${betType} ${line}`;
  }
  return line >= 0 ? `+${line}` : `${line}`;
}

export function formatEv(ev: number): string {
  const rounded = Number(ev.toFixed(1));
  return `${rounded >= 0 ? "+" : ""}${rounded.toFixed(1)}%`;
}

export function isNegativeEv(ev: number): boolean {
  return formatEv(ev).startsWith("-");
}

export function slipEvClass(ev: number): string {
  return isNegativeEv(ev) ? "border-destructive/30 bg-destructive/20 text-destructive" : "border-accent-value/30 bg-accent-value/20 text-accent-value";
}

export function formatAmericanOdds(odds: number): string {
  return odds >= 0 ? `+${odds}` : `${odds}`;
}

export function normalizeCapitalization(str: string): string {
  return str
    .split(" ")
    .map((word) => {
      if (word.length > 1 && word === word.toUpperCase()) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word;
    })
    .join(" ");
}
